/**
 * Function to get and set dataLayer
 * @param dataLayer - The dataLayer
 * @param dataLayerName - The dataLayer name
 */ const getDataLayerSnippet = (dataLayer, dataLayerName = 'dataLayer')=>`window.${dataLayerName} = window.${dataLayerName} || []; window.${dataLayerName}.push(${JSON.stringify(dataLayer)})`;
/**
 * Function to get the Iframe snippet
 * @param environment - The parameters to use a custom environment
 * @param id - The id of the container
 */ const getIframeSnippet = (id, environment)=>{
    let params = ``;
    if (environment) {
        const { gtm_auth, gtm_preview } = environment;
        params = `&gtm_auth=${gtm_auth}&gtm_preview=${gtm_preview}&gtm_cookies_win=x`;
    }
    return `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}${params}" height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`;
};
const getConsentInitializationSnippet = (dataLayerName = 'dataLayer')=>{
    return `
    window.${dataLayerName} = window.${dataLayerName} || [];
  
    function gtag() {
        ${dataLayerName}.push(arguments);
    }

    gtag('set', 'developer_id.dNzMyY2', true);

    /* We are blocking all cookies upon consent for Europe */
    gtag('consent', 'default', {
        'ad_user_data':'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update' : 500,
        'region': [
            'AT', // Austria
            'BE', // Belgium
            'BG', // Bulgaria
            'CH', // Switzerland
            'CY', // Cyprus
            'CZ', // Czech Republic
            'DE', // Germany
            'DK', // Denmark
            'EE', // Estonia
            'ES', // Spain
            'FI', // Finland
            'FR', // France
            'GB', // United Kingdom of Great Britain and Northern Ireland
            'GR', // Greece
            'HR', // Croatia
            'HU', // Hungary
            'IE', // Ireland
            'IS', // Iceland
            'IT', // Italy
            'LT', // Lithuania
            'LV', // Latvia
            'MK', // The former Yugoslav Republic of Macedonia
            'MT', // Malta
            'NL', // Netherlands
            'NO', // Norway
            'PL', // Poland
            'PT', // Portugal
            'RO', // Romania
            'RS', // Serbia
            'SE', // Sweden
            'SI',  // Slovenia
            'RU',  // Russia
            'BY',  // Belarus
            'CN'  // China
        ]
    });

    /* For other regions storages are granted by default */
    gtag('consent', 'default', {
        'ad_user_data':'granted',
        'ad_personalization': 'granted',
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'wait_for_update' : 500
    });

    gtag('set', 'ads_data_redaction', true);
  `;
};
const getGTMScript = (dataLayerName = 'dataLayer', id, environment)=>{
    let params = ``;
    if (environment) {
        const { gtm_auth, gtm_preview } = environment;
        params = `+"&gtm_auth=${gtm_auth}&gtm_preview=${gtm_preview}&gtm_cookies_win=x"`;
    }
    return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl${params};f.parentNode.insertBefore(j,f);
    })(window,document,'script','${dataLayerName}','${id}');
  `;
};

export { getConsentInitializationSnippet, getDataLayerSnippet, getGTMScript, getIframeSnippet };
